import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../api.service';
// import { IndividualTrip } from '../../shared/individual-trip.model';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-view-ride-detail',
  templateUrl: './view-ride-detail.component.html',
  styleUrls: ['./view-ride-detail.component.scss'],
})
export class ViewRideDetailComponent implements OnInit {
  data: any;
  isSubmitting = true;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public api: ApiService,
    private title: Title,
    private meta: Meta
  ) {}

  ngOnInit() {
    this.title.setTitle('Matesride Autoscoop - Ride Details | Rider Info | Rider Details | Ride Timings | Ride To | Ride From');
    this.meta.updateTag({ name : 'description', content: 'Get the Ride info,Timings To & from , Crazy Rides'});
    this.meta.updateTag({ name : 'keywords', content: 'Ride Details, Trip Details, Ride Info, Trip Info, Ride Information, Trip Information, Trip status, Ride Status, Ride Timings, Ride Share, Rides Available, Trips Available, Best Rides '});
    this.route.params.subscribe(params => {
      this.parseData(params.id);
    });
  }

  parseData(id: number) {
    this.api.getRideByRideID(id).subscribe(
      r => {
        this.data = r;
        this.meta.updateTag({
          name: 'description',
          content: '#AutoScoop #Matesride #from #to check',
        });
        this.isSubmitting = false;
      },
      error => {
        this.data = null;
        console.log(error);
      }
    );
  }
}
